// extracted by mini-css-extract-plugin
export default {"btnRow":"styles_btnRow__R4oEv","btn":"styles_btn__fDpnl","btnBox":"styles_btnBox__Scnb2"};